import { entityPath } from '@peles/shared';

/**
 * Where an in-app notification opens.
 *
 * A notification may carry its own `data.path` — a task notification does,
 * because a client's tasks are in the portal and the office's on the event,
 * and the record alone cannot say which. Otherwise the record's own page, from
 * the same map the backend builds `{{link}}` from. `null` means it opens
 * nowhere; only an in-app path is ever followed.
 */
export function notificationPath(notification: {
  entityType?: string | null;
  entityId?: string | null;
  data?: Record<string, unknown> | null;
}): string | null {
  const path = notification.data?.path;
  if (typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')) return path;
  return entityPath(notification.entityType, notification.entityId);
}
